import React, { useRef } from 'react';
import ProductCard from './ProductCard';

const ProductRow = ({ title, icon, products, id }) => {
  const scrollRef = useRef(null);
  const scroll = (dir) => scrollRef.current.scrollBy({ left: dir * 320, behavior: 'smooth' });

  return (
    <section className="product-row" id={id}>
      <div className="product-row__header">
        <div className="section-label">
          <span className="section-icon">{icon}</span>
          <h2 className="section-title">{title}</h2>
        </div>
        <div className="scroll-controls">
          <button className="scroll-btn" onClick={() => scroll(-1)} aria-label="Scroll left">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M15 18l-6-6 6-6"/>
            </svg>
          </button>
          <button className="scroll-btn" onClick={() => scroll(1)} aria-label="Scroll right">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>
      <div className="product-row__track" ref={scrollRef}>
        {products.map(p => (
          <div className="product-row__item" key={p.id}>
            <ProductCard product={p} />
          </div>
        ))}
      </div>
    </section>
  );
};

export default ProductRow;
